import { useSEO } from "../../hooks/useSEO";

const CookiePolicy = () => {
  useSEO({
    title: "Cookie Policy",
    description: "TaxShift 2026 Cookie Policy — what cookies we use, why, and how to control them.",
    path: "/cookie-policy",
  });

  return (
    <div className="py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="font-mono uppercase text-[10px] tracking-[0.3em] text-muted-foreground mb-4 block">
          Compliance · Cookies
        </span>
        <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mb-3">Cookie Policy</h1>
        <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-10 pb-6 border-b-2 border-foreground">
          Last updated: February 2026
        </p>
        <div className="font-body text-base leading-relaxed space-y-5 text-foreground/85">
          <p>
            This Cookie Policy explains how TaxShift 2026 uses cookies and similar technologies on
            our website. It supplements our Privacy Policy.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">What are cookies?</h2>
          <p>
            Cookies are small text files placed on your device when you visit a website. They help
            sites remember your preferences, measure audience, and (in advertising contexts) show
            relevant ads.
          </p>
          <h2 className="font-heading text-2xl font-semibold mt-8">Types of cookies we use</h2>

          <div className="border-2 border-foreground mt-4">
            <div className="p-5 border-b border-foreground/20 bg-card">
              <div className="flex items-start justify-between gap-4 mb-2">
                <h3 className="font-heading text-xl font-semibold">Strictly necessary</h3>
                <span className="font-mono text-[10px] uppercase tracking-widest bg-primary text-primary-foreground px-2 py-1">Always active</span>
              </div>
              <p className="text-sm">
                Required for core site functionality — routing, session state, and remembering your
                cookie-consent choice. These cannot be disabled.
              </p>
            </div>
            <div className="p-5 border-b border-foreground/20 bg-card">
              <div className="flex items-start justify-between gap-4 mb-2">
                <h3 className="font-heading text-xl font-semibold">Analytics</h3>
                <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Optional</span>
              </div>
              <p className="text-sm">
                PostHog and similar providers help us measure aggregate page views, session
                duration, and feature usage — with no personally identifiable data.
              </p>
            </div>
            <div className="p-5 bg-card">
              <div className="flex items-start justify-between gap-4 mb-2">
                <h3 className="font-heading text-xl font-semibold">Advertising</h3>
                <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Optional</span>
              </div>
              <p className="text-sm">
                Google AdSense serves contextual ads that help fund the free calculators. With your
                consent, AdSense may use cookies to measure ad performance.
              </p>
            </div>
          </div>

          <h2 className="font-heading text-2xl font-semibold mt-8">How to control cookies</h2>
          <p>
            You can accept, reject, or customize cookies via the consent banner that appears on
            your first visit. You can also change your choice at any time by clearing your browser
            storage or using your browser's privacy controls. EU/UK/EEA visitors: your consent is
            required before non-essential cookies are set, per the ePrivacy Directive and GDPR.
          </p>

          <h2 className="font-heading text-2xl font-semibold mt-8">Do Not Track</h2>
          <p>
            We honor browser "Do Not Track" signals where technically feasible for analytics and
            advertising cookies.
          </p>

          <h2 className="font-heading text-2xl font-semibold mt-8">Contact</h2>
          <p>
            Questions: <strong>privacy@taxshift2026.com</strong>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
